import * as usersActions from '../states/users.actions';

import { Action, createReducer, on } from '@ngrx/store';
import { ICLientUsersState, initialClientUserState } from './users.state';

import { UserKindEnum } from '../enums/user-kind.enum';

const usersReducer = createReducer(
  initialClientUserState,
  on(usersActions.getAllUsersV3, (state, action) => {
    const usersV3 = [];
    const queryParameters =
      action?.payload !== null && action?.payload !== undefined
        ? { ...state.queryParameters, ...action.payload }
        : {
            pageNumber: 1,
            pageSize: 10,
            sortField: null,
            filterFields: [],
          };
    return {
      ...state,
      usersV3,
      queryParameters,
    };
  }),
  on(usersActions.getAllUsersV3Success, (state, action) => {
    const newUsers = [...state.usersV3, ...action.payload.usersV3];
    return {
      ...state,
      usersV3: newUsers,
      paginationV3: {
        currentPage: action.payload.paginationV3.currentPage,
        pages: action.payload.paginationV3.pages,
        nextPage: action.payload.paginationV3?.nextPage,
        prevPage: action.payload.paginationV3?.prevPage,
        totalRecords: action.payload.paginationV3?.totalRecords,
        sizePage: action.payload.paginationV3?.sizePage,
      },
    };
  }),
  on(usersActions.ResetPage, (state, action) => ({
    ...state,
    queryParameters: {
      pageNumber: 1,
      pageSize: 10,
      sortField: null,
      filterFields: [],
    },
    usersV3: [],
  })),
  on(usersActions.updateUsersV3ById, (state, action) => ({
    ...state,
    userIdEdit: action.clientUserId,
  })),
  on(usersActions.updateUsersV3ByIdSuccess, (state, action) => ({
    ...state,
    paginationV3: {
      currentPage: 1,
      pages: state.paginationV3.pages,
      nextPage: state.paginationV3?.nextPage,
      prevPage: state.paginationV3?.prevPage,
      totalRecords: state.paginationV3?.totalRecords,
      sizePage: state.paginationV3?.sizePage,
    },
    usersV3: [],
  })),
  on(usersActions.saveUsersV3Success, (state, action) => ({
    ...state,
    paginationV3: {
      currentPage: 1,
      pages: state.paginationV3.pages,
      nextPage: state.paginationV3?.nextPage,
      prevPage: state.paginationV3?.prevPage,
      totalRecords: state.paginationV3?.totalRecords,
      sizePage: state.paginationV3?.sizePage,
    },
    usersV3: [],
  })),
  on(usersActions.deleteUsersV3Success, (state, action) => ({
    ...state,
    paginationV3: {
      currentPage: 1,
      pages: state.paginationV3.pages,
      nextPage: state.paginationV3?.nextPage,
      prevPage: state.paginationV3?.prevPage,
      totalRecords: state.paginationV3?.totalRecords,
      sizePage: state.paginationV3?.sizePage,
    },
    usersV3: [],
  })),
  on(usersActions.errorConf, (state, action) => ({
    ...state,
    erroRegister: action.error,
    errors: action?.error?.error?.detail,
  })),
  on(usersActions.errorloginConf, (state, action) => ({
    ...state,
    errorLogin: action.error,
  })),
  on(usersActions.changeSortColumn, (state, action) => ({
    ...state,
    sortColumn: action.payload,
    paginationV3: {
      nextPage: state.paginationV3?.nextPage,
      prevPage: state.paginationV3?.prevPage,
      totalRecords: state.paginationV3?.totalRecords,
      currentPage: 1,
      sizePage: state.paginationV3?.sizePage,
      pages: state.paginationV3?.pages,
    },
    usersV3: [],
  })),
  on(usersActions.changeUserKindFilter, (state, action) => ({
    ...state,
    userKind: action.payload,
    usersV3: [],
    paginationV3: {
      nextPage: state.paginationV3?.nextPage,
      prevPage: state.paginationV3?.prevPage,
      totalRecords: state.paginationV3?.totalRecords,
      currentPage: 1,
      sizePage: state.paginationV3?.sizePage,
      pages: state.paginationV3?.pages,
    },
  })),
  on(usersActions.getUserProfilesSuccess, (state, action) => ({
    ...state,
    profiles: action?.payload?.profiles,
  })),
  on(usersActions.getUsersDashboardV3Success, (state, action) => {
    const flows = [...action.payload.flows].map((flow) => {
      if (flow.flowKey === UserKindEnum.Responsible) {
        flow = { ...flow, color: '#dc3545' };
      }
      if (flow.flowKey === UserKindEnum.Collaborator) {
        flow = { ...flow, color: '#6c757d' };
      }
      return flow;
    });
    return {
      ...state,
      dashboardV3: { ...action.payload, flows },
    };
  }),
  on(usersActions.GetInfoSuccess, (state, action) => ({
    ...state,
    info: action.payload.info,
  })),
  on(usersActions.getReceiversSuccess, (state, action) => ({
    ...state,
    departmentReceivers: action.payload.departmentReceivers,
  })),
  on(usersActions.GetInfoError, (state, action) => ({
    ...state,
    info: {
      lookFeelConfig: {
        emailEmphasisColor: null,
        emailLogoName: null,
        emailLogo64: null,
        webEmphasisColor: null,
        webNavigationColor: null,
        webLogoName: null,
        webLogo64: null,
      },
    },
  })),
  on(usersActions.GetLookFeelSuccess, (state, action) => ({
    ...state,
    info: {
      ...state.info,
      lookFeelConfig: action.payload.lookFeel,
    },
  }))
);

export function clientUserReducer(state: ICLientUsersState, action: Action) {
  return usersReducer(state, action);
}
